
    export const ApplicationStyles = {
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: (theme) => theme.spacing(2)
    },
    FirstApplicationItemStyles = {
        padding: "8px"
    },
    ApplicationItemStyles = {
        paddingLeft: "8px",
        paddingBottom: "6px"
    },
    LastApplicationItemStyles = {
        paddingLeft: "8px"
    },
    ApplicationButtonsStyles = {
        marginTop: "auto",
        marginBottom: "2px"
    },
    DropdownStyles = {
        marginTop: (theme) => theme.spacing(4),
        marginBottom: (theme) => theme.spacing(3)
    },
    ToggleStyles = {
        marginTop: (theme) => theme.spacing(4)
    }
